import { formatNumber } from '@sentinel/web-core';
import { StateBadge } from '@sentinel/ui';
import { useTranslation } from 'react-i18next';
import { useStationHere } from '@/core/station/use-station';
import { LEVEL_TONE } from '@/core/station/level-tone';

/** The link of the station this browser sits at, next to the services in the status bar
 *  (CLAUDE.md §32): its level by glyph, colour and word, the active link and its speed.
 *  Nothing when no station is chosen. */
export function StationService() {
  const { t } = useTranslation();
  const station = useStationHere();
  if (station === null) return null;
  const active = station.links.find((l) => l.active && l.state !== 'down') ?? null;
  const speed =
    active?.downMbps == null
      ? null
      : t('connectivity.mbps', {
          value: formatNumber(active.downMbps, { maximumFractionDigits: 0 }),
        });
  return (
    <span className="u">
      <b>{t('shell.nav.serviceLink', { station: station.code })}</b>
      <StateBadge
        tone={LEVEL_TONE[station.level]}
        label={
          station.level === 'offline' || active === null
            ? t(`connectivity.levels.${station.level}`)
            : t('connectivity.linkShort', { link: active.label, speed: speed ?? '—' })
        }
      />
    </span>
  );
}
